import { Setting } from '../types/constant/PagesPropsType';
import { SubscriptionApiType } from '../types/api/SubscriptionApiType';
import axios from 'axios';
import { CUSTOMER_API_URL } from '../constants';

export const usePaymentMethodUpdate = () => {
  /**
   * クレジット情報を更新するためのメールを送信する
   *
   * @param setting
   * @param subscription
   * @param success
   * @param failed
   * @param completion
   */
  const paymentMethodUpdate = (
    setting: Setting,
    subscription: SubscriptionApiType,
    success: () => void,
    failed: () => void,
    completion: () => void
  ) => {
    axios
      .post(
        `${CUSTOMER_API_URL}?action=paymentMethodUpdate`,
        { subscriptionId: subscription.subscriptionContractId },
        { headers: { Authorization: setting.token } }
      )
      .then((response) => {
        success();
      })
      .catch((e) => {
        console.log(e);
        failed();
      })
      .finally(() => completion());
  };

  return {
    paymentMethodUpdate,
  };
};
